module.exports = __webpack_public_path__ + "static/img/guiluyaoye.c35cb946.png";